/**
 * Process API Client
 * Handles all API calls for Process entities
 */

import { BaseApiClient, ApiResponse, RequestOptions } from './baseApiClient';
import { API_ENDPOINTS } from '../config/apiEndpoints';
import {
  Process,
  CreateProcessRequest,
  UpdateProcessRequest,
  StandardListRequest,
  GetByIdRequest,
  DeleteRequest,
  SearchRequest,
} from '../types';

export class ProcessApiClient extends BaseApiClient {
  async getAll(request: StandardListRequest = {}): Promise<ApiResponse<Process[]>> {
    return this.postQuery<Process[]>(API_ENDPOINTS.PROCESSES.LIST, request);
  }

  async getById(request: GetByIdRequest): Promise<ApiResponse<Process>> {
    return this.postQuery<Process>(API_ENDPOINTS.PROCESSES.GET_BY_ID, { ID: { ID: request.id, ResID: '' } });
  }

  async create(request: CreateProcessRequest): Promise<ApiResponse<Process>> {
    return this.post<Process>(API_ENDPOINTS.PROCESSES.CREATE, request);
  }

  async update(request: UpdateProcessRequest): Promise<ApiResponse<Process>> {
    // C# API expects the full entity including ProcessID in the body
    // The controller validates that the ID in the body matches the ID in the route
    return this.put<Process>(API_ENDPOINTS.PROCESSES.UPDATE(request.ProcessID), request);
  }

  async deleteProcess(request: DeleteRequest): Promise<ApiResponse<void>> {
    // C# API expects DeleteWebRequest with ID property
    const deleteRequestBody = {
      ID: {
        ID: request.id,
        ResID: '',
      },
    };
    return super.delete<void>(API_ENDPOINTS.PROCESSES.DELETE(request.id), deleteRequestBody);
  }

  async getByProject(projectId: number, request: SearchRequest = {}, options?: RequestOptions): Promise<ApiResponse<Process[]>> {
    return this.postQuery<Process[]>(API_ENDPOINTS.PROCESSES.BY_PROJECT, { ...request, ProjectID: projectId }, options);
  }

  async getTemplates(request: SearchRequest = {}): Promise<ApiResponse<Process[]>> {
    return this.postQuery<Process[]>(API_ENDPOINTS.PROCESSES.TEMPLATES, request);
  }
}

export const processApiClient = new ProcessApiClient();
